import type { BreadcrumbList, WithContext } from "schema-dts";
import { ORG, STRUCTURED_DATA_IDS } from "@/content/_site.config";
import { buildBreadcrumbListSchema, formatForLabel } from "@/lib/utils";

export function buildBreadcrumbFromPath(
  pathname: string,
  labels?: string[],
): WithContext<BreadcrumbList> {
  const url = ORG.url;
  const clean = pathname.split("?")[0].split("#")[0].replace(/\/+$/, "") || "/";
  const segs = clean === "/" ? [] : clean.split("/").filter(Boolean);

  const crumbs = [{ name: "Home", url: `${url}/` }];

  if (segs.length) {
    segs.forEach((_, i) => {
      const partial = `/${segs.slice(0, i + 1).join("/")}`;
      const name = labels?.[i] ?? formatForLabel(segs[i]);
      crumbs.push({ name, url: `${url}${partial}` });
    });
  }

  const schema = buildBreadcrumbListSchema(crumbs);
  schema["@id"] = STRUCTURED_DATA_IDS.breadcrumb(pathname);

  return schema;
}
